import React, { useEffect, useState, useRef} from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureToggleActions from "../../../store/actions/FeatureToggle";
import * as FeatureActions from "../../../store/actions/Feature";
import * as CountryActions from "../../../store/actions/Country";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import * as UserActions from "../../../store/actions/User";
import * as DriverServicesActions from "../../../store/actions/DriverServices";
import * as CarrierActions from "../../../store/actions/Carriers";
import styled from "styled-components";
import Textarea from "sushiweb/InputTypes/Textarea";
// import { getDriverCategoryList } from "../../../store/actions/DriverCategory";
import {
  getInitialState,
  capitalizeFirstLetter,
  getSortedList,
  isValNull,
  parseString,
} from "../../../utils";
import {
  isValidated,
  getReadableDateTime,
  filterObj,
  isDSMDropdownEnabled,
} from "../../../utils";
import FileUpload from "../../Common/FileUpload";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings.js";
import ChangeLogTableFields from "../../../constants/ChangeLogs/ChangeLogTableFields.json";
import ChangeLogList from "../../Common/ChangeLogList";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import variables from "../../../constants/assets/variables";
import NoFooterModal from "../../Common/NoFooterModal";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import TimePickerInput from "../../Common/TimePickerInput";
import MultiSelectCheckboxDropdown from "../../Common/MultiSelectCheckboxDropdown";
import InformationBar from "../../Common/InformationBar";

import {
  BottomSectionModal,
  Link,
  FlexContainer,
} from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import _ from "lodash-es";
import * as Comparators from "../../../constants/FeatureToggle/Comparators";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import { set } from "date-fns";
const scopeOptions = [
  { key: "driver", label: "Driver" },
  { key: "merchant", label: "Merchant" },
  { key: "customer", label: "Customer" },
];

const statusOptions = [
  { key: "both", label: "Both(Enable & Disable)" },
  { key: "disable", label: "Disable" },
  { key: "enable", label: "Enable" },
];

const entityTypeOptions = [
  { key: "User", label: "User" },
  { key: "Locality", label: "Locality" },
  { key: "City", label: "City" },
  { key: "Country", label: "Country" },
];

const entitySubTypeOptions = [
  { key: "USER_ID", label: "User Id" },
  { key: "MERCHANT_EXTERNAL_ID", label: "Merchant External Id" },
  { key: "ZOMATO_RESTAURANT_ID", label: "Zomato External Id" },
];

const mandatoryFields = [
  "featureName",
  "featureScope",
  "entityValue",
  "entityType",
];
const disabledFieldsInEditState = [
  "featureName",
  "featureScope",
  "entityValue",
  "entityType",
  "setConditions",
  "activeCityId",
  "entitySubType",
];
// let callback_key,presign_url = "";
const [bulk_upload_url, simple_url] = [
  "/feature/toggle/bulk",
  "/feature/toggle/upsert",
];

const isToggleEnabledUrl = "/feature/toggle/enabled";

const conditionTypeOptions = [
  { key: "service_id", label: "Delivery Services" },
  { key: "app_version", label: "App Version" },
  { key: "validate_time", label: "Time" },
  { key: "carrier_id", label: "Carrier ID" },
  { key: "source_id", label: "Source ID" },
  { key: "is_slot_driver", label: "Slot Driver" },
];
const slotDriverOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" }
];
const comparatorOptions = [
  { key: Comparators.GT, label: "Greater than" },
  { key: Comparators.LT, label: "Less than" },
  { key: Comparators.EQ, label: "Equals to" },
  { key: Comparators.NOT_EQ, label: "Not equals to" },
  { key: Comparators.IN, label: "In" },
  { key: Comparators.NOT_IN, label: "Not in" },
  { key: Comparators.GTE, label: "Greater than and equals to" },
  { key: Comparators.LTE, label: "Less than and equals to" },
];

export const FeatureToggleFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeId,
    activeFeatureToggle,
    activeFiltersToggle,
    filterFields,
    getCountryList,
    getLocalityList,
    getCityList,
    nextPageCity,
    featureList,
    getFeatureList,
    currentPageFeatureToggle,
    setStatus,
    nextPageCountry,
    getCountry,
    getCity,
    getDriverServices,
    getDriverServiceByIds,
    getCarriersList,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.FEATURE_TOGGLE];
  const [activeCityId, setActiveCityId] = useState("");
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [activeFile, setActiveFile] = useState("");
  const [priorityFlag, setPriorityFlag] = useState(0);
  const [featureEnabledTextDisplay,setFeatureEnabledTextDisplay]= useState("")
  const [toggleStatus, setToggleStatus] = useState(null);
  const [startTime, setStartTime] = useState("00:00:00");
  const [endTime, setEndTime] = useState("00:00:00");
  const slotDriverInitialState = useRef("");
  const [selectedCarrierIds, setSelectedCarrierIds] = useState([]);
  const carrierIds = useRef([]);
  const carrierIdOptions = useRef([]);

  const [initialState, setInitialState] = useState({
    featureName: "",
    featureScope: "",
    entityValue: "",
    entityType: "",
    enabled: null,
    setConditions: true,
    entitySubType: "",
    updatedAt: "",
    id: "",
    changes: [],
    serviceId: [],
    conditions: "[]",
    conditionsList: [],
  });
  const [dropDownModalState, setDropDownModalState] = useState(modalState);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (
      process.env.REACT_APP_ENV === "production" &&
      (modalState === "Edit" || modalState === "Add")
    ) {
      const prodSubmitConfirmationModal = window.confirm(
        "[PRODUCTION ENV] are you sure you want to make these changes?"
      );
      if (!prodSubmitConfirmationModal) return;
    }

    const body = filterObj(initialState, [
      "featureName",
      "featureScope",
      "enabled",
      "entityValue",
      "entityType",
      "entitySubType",
      "conditions",
      "setConditions",
    ]);

    //if filter button is clicked then apply filters
    if (modalState === "Filter") {
      let filters = {};
      for (let key of filterFields) {
        if (
          (key === "enabled" && body[key] !== null && body[key] !== "") ||
          body[key]
        ) {
          filters[key] = body[key] + "";
        }
      }
      props.getFeatureToggleList(filters).then((res) => {
        handleClose();
      });
    }

    else if (modalState === "Check") {        
      let body = filterObj(initialState, [
        "featureName",
        "featureScope",
        "entityValue",
        "entityType"
      ]);
       
      let values_to_test = { ...body };
      let mandatoryFieldsToCheck = [...mandatoryFields];
      
      let checkValidatedState = isValidated(values_to_test, mandatoryFieldsToCheck);

      if (checkValidatedState === "validated") {
        if (body.entityType == "User" && body.featureScope == "driver") {
          body.entityType = "Driver"
        }
        body.clientId="1"
        body.doNotUpsert= "true"
        props
        .checkFeatureToggleEnabled(
          isToggleEnabledUrl,
          body
        )
        .then((res) => {
          if(res && "enabled" in res && res.enabled == true) {
            setFeatureEnabledTextDisplay(true)
          }
          else if (res && "enabled" in res && res.enabled == false) {
            setFeatureEnabledTextDisplay(false)
          }
          else {
            setStatus({ type: "error", message: "Unable to fetch" });
          }
        })
      }
      else {
        setStatus({ type: "error", message: "Mandatory feilds missing" });
      }
    } 
    else {
      //before hitting api, check if all validations like mandatory fields are satisfied
      //consider bulk upload and change url path according to that
      let values_to_test = { ...body };
      let mandatoryFieldsToCheck = [...mandatoryFields];
      if (isBulkUpload) {
        delete values_to_test.entityValue;
        values_to_test["file"] = activeFile;
        mandatoryFieldsToCheck.push("file");
      }
      body.enabled =
        typeof body["enabled"] === "boolean" ? body["enabled"] : false;
      let validatedState = isValidated(values_to_test, mandatoryFieldsToCheck);

      let conditions = body["conditions"];

      // `conditions` should be in correct json format
      try {
        if (conditions === "") {
          conditions = "null";
        }
        const val = JSON.parse(conditions);
        body["conditions"] = val;
      } catch {
        validatedState = "value of `conditions` is not in correct JSON format";
      }
        
      if (validatedState === "validated") {
        props
          .createFeatureToggle(
            isBulkUpload ? bulk_upload_url : simple_url,
            body
          )
          .then((res) => {
            if (res) {
              // [callback_key,presign_url] = [res.callbackKey,res.fileUploadUrl];
              setCallback_key(res.callbackKey);
              setPresign_url(res.fileUploadUrl);
              let pageRequest = {
                page: currentPageFeatureToggle,
              };
              !isBulkUpload &&
                props.getFeatureToggleList(activeFiltersToggle, pageRequest);
              !isBulkUpload && handleClose();
            }
          });
      } 
      else {
        setStatus({ type: "error", message: validatedState });
      }
    }
  };


  const handleClearFilters = () => {
    props.getFeatureToggleList({}).then((res) => {
      props.resetStateFeatureToggle({ state: "activeFiltersToggle" });
      handleClose();
    });
  };

  const handleChange = (key, val, extraParams) => {
    let values = { ...initialState };
    values[key] = val;
    if (key === "entityType") {
      values["entityValue"] = "";
      values["entitySubType"] = "";
      setActiveCityId("");
      setPriorityFlag(true);
    } else if (key === "featureScope") {
      values["featureName"] = "";
      values["conditions"] = "[]";
      values["conditionsList"] = [];
    } else if (key === "entityValue") {
      values[key] = val + "";
      setPriorityFlag(false);
    }
    else if(key==  "slot_driver"){
      handleConditionListChange("Value", val, extraParams[0]);
      return;
    }
    //set values of entity subtype according to feature scope when entityType is User
    if (key === "entityType" || key === "featureScope") {
      if (values["entityType"] === "User" && values["featureScope"]) {
        if (values["featureScope"] === "driver") {
          values["entitySubType"] = "DRIVER_ID";
        } else if (values["featureScope"] === "customer") {
          values["entitySubType"] = "PUBLIC_CUSTOMER_ID";
        } else {
          values["entitySubType"] = "";
        }
      }
    }
    setInitialState(values);
  };

  const handleTimeChange = (key, value, extraParams) => {
    var start_time= startTime
    var end_time= endTime
     
    if(extraParams.type=="start") {
        start_time = value.format("HH:mm:ss"); 
        setStartTime(value ? start_time : "");
      }
    if(extraParams.type=="end") {
        end_time = value.format("HH:mm:ss"); 
        setEndTime(value ? end_time : "");
      }

    handleConditionListChange("Value", "validate_time", extraParams.index, {"start_time": start_time, "end_time": end_time})
  };

  const handleCarrierIdChange = (key, val, index) => {
    setSelectedCarrierIds(val);
    const carrierIdsKeysArray = val.map((carrier_type) => {
      const option = carrierIdOptions.current.find((item) => item.carrier_type === carrier_type);
      return option ? option.id : null;
    })
    carrierIds.current = carrierIdsKeysArray;
    handleConditionListChange("Value", "carrier_id", index.index, {"carrier_ids" : carrierIdsKeysArray})
}

  const handleConditionListChange = (key, val, index, obj) => {
    let values = { ...initialState };
    values.conditionsList[index][key] = val;
    if (key == "Name") {
      if(val == "app_version"){
        values.conditionsList[index]["Comparator"]= Comparators.GTE;
      }
      else if(val == "is_slot_driver"){
        values.conditionsList[index]["Comparator"]= Comparators.EQ;
      }
      else{
        values.conditionsList[index]["Comparator"]= Comparators.IN;
      }

      values.conditionsList[index]["Value"] =
        val == "app_version" || val == "service_id" || val == "carrier_id" ? "" : "[]";
        
       if(val == "validate_time"){
          values.conditionsList[index]["Value"]="00:00:00"
          }
    }
    if (
      key == "Comparator" &&
      values.conditionsList[index]["Name"] != "service_id"
    ) {
      values.conditionsList[index]["Value"] =
        val == Comparators.IN || val == Comparators.NOT_IN ? "[]" : "";
    }

    if (key == "Comparator" && values.conditionsList[index]["Name"] == "carrier_id") {
        setSelectedCarrierIds([])
      }

    setInitialState(values);

    // to set conditions
    let tempConditions = [];
    initialState.conditionsList.map((detailCondition, i) => {
      if (
        (detailCondition.Name !== "" &&
          detailCondition.Value !== "" &&
          detailCondition.Value !== "[]") ||
        (Array.isArray(detailCondition.Value) && detailCondition.Value.length)
      ) {
        if(detailCondition.Name == "validate_time"){
          {
            var newTime
            if (obj && "start_time" in obj && "end_time" in obj){
            newTime = [obj.start_time,obj.end_time];
            }
            else{
            newTime = [startTime,endTime];
            }
            detailCondition.Value = newTime;
            tempConditions = [...tempConditions, detailCondition];
          }
        }

        else if (detailCondition.Name == "carrier_id") {
          if (obj && "carrier_ids" in obj) {
             detailCondition.Value = obj.carrier_ids
          }
          else {
              detailCondition.Value = carrierIds.current
          }
          tempConditions = [...tempConditions, detailCondition]
      }

        else if (detailCondition.Name != "service_id") {
          try {
            let oldVal = _.cloneDeep(detailCondition.Value); // storing actual value
            detailCondition.Value = JSON.parse(detailCondition.Value); // parsing the value array
            let updatedDetailCondition = _.cloneDeep(detailCondition);
            tempConditions = [...tempConditions, updatedDetailCondition]; // update the parsed value in conditions
            detailCondition.Value = oldVal; // storing back the old value
          } catch {
            tempConditions = [...tempConditions, detailCondition];
          }
        } else {
          tempConditions = [...tempConditions, detailCondition];
        }
      }
      // if condition value is not there, remove that condition
      if (
        ((detailCondition.Value === "" ||
          detailCondition.Value === "[]"))||
        (Array.isArray(detailCondition.Value) &&
          detailCondition.Value.length == 0)
      ) {
          tempConditions.splice(i, 1);
        }
    });
    if (Array.isArray(tempConditions) && tempConditions.length) {
      setInitialState((prevState) => {
        return {
          ...prevState,
          ["conditions"]: JSON.stringify(tempConditions),
        };
      });
    }
    if (Array.isArray(tempConditions) && tempConditions.length == 0) {
      setInitialState((prevState) => {
        return {
          ...prevState,
          ["conditions"]: JSON.stringify(tempConditions),
        };
      });
    }
  };

  const handleStatusChange = (key, val) => {
    const values = { ...initialState };
    if (val === "enable") {
      values["enabled"] = true;
    } else if (val === "disable") {
      values["enabled"] = false;
    } else {
      values["enabled"] = null;
    }
    setToggleStatus(val);
    setInitialState(values);
  };

  const setActiveCity = (value) => {
    let values = { ...initialState };
    values["entityValue"] = "";
    setInitialState(values);
    setActiveCityId(value);
  };

  const getLabelValue = (dependentField) => {
    if (dependentField === "entitySubType" && modalState === "Check") {
      return initialState[dependentField]
        ? "Delivery_Driver_ID/Driver_FE_ID"
        : "";
    }
    switch (dependentField) {
      case "entitySubType":
        return initialState[dependentField]
          ? `${capitalizeFirstLetter(initialState[dependentField])}${
              initialState[dependentField] === "DRIVER_ID"
                ? "(Starts With FE)"
                : ""
            }`
          : "Toggle For";
      default:
        return "Toggle For";
    }
  };

  //handle bulk upload -> if available or not
  const handleCheckBoxChange = (e) => {
    setIsBulkUpload(e);
  };

  const getEntitySubType = () => {
    return initialState.featureScope === "merchant" &&
      initialState.entityType === "User" ? (
      <PaginatedReactDropdown
        options={entitySubTypeOptions}
        disabled={checkIfDisabled("featureScope")}
        data-testid="featureToggleEntitySubType"
        labelKey="label"
        valueKey="key"
        labelWidth="18%"
        value={getInputLabel(
          initialState.entitySubType,
          entitySubTypeOptions,
          "key",
          "label"
        )}
        handleChange={handleChange}
        keyToChange="entitySubType"
        placeholder="Entity SubType"
        showCross={false}
        id="entitySubTypeDropdown"
      />
    ) : (
      ""
    );
  };

  const getEntityValueFields = () => {
    switch (initialState.entityType) {
      case "User":
        return (
          <React.Fragment>
            <Input
              value={initialState.entityValue}
              data-testid="updatedAt"
              id="sushi-input"
              onChange={(e) => handleChange("entityValue", e)}
              disabled={checkIfDisabled("entityValue")}
              label={getLabelValue("entitySubType")}
            />
          </React.Fragment>
        );
      case "Country":
        return (
          <InfiniteScrollDropdown
            setPriorityFlag={setPriorityFlag}
            priorityFlag={priorityFlag}
            id="countryDropdown"
            appliedFilters={{}}
            getActiveList={getCountryList}
            nextPage={nextPageCountry}
            resKey="countries"
            modalState={modalState}
            keyName="entityValue"
            labelKey="country_name"
            getDataLabelKey="country.country_name"
            keyTypeToSet="id"
            disabled={checkIfDisabled("entityValue")}
            label="Country"
            handleChange={handleChange}
            remoteSearchApplicable={false}
            activeFilters={activeFiltersToggle}
            activeElement={activeFeatureToggle}
            getActiveItemById={getCountry}
          />
        );
      case "City":
        return (
          <InfiniteScrollDropdown
            id="cityDropdown"
            setPriorityFlag={setPriorityFlag}
            priorityFlag={priorityFlag}
            appliedFilters={{}}
            getActiveList={getCityList}
            nextPage={nextPageCity}
            resKey="cities"
            modalState={modalState}
            keyName="entityValue"
            labelKey="city_name"
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            disabled={checkIfDisabled("entityValue")}
            label="City"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            activeFilters={activeFiltersToggle}
            activeElement={activeFeatureToggle}
            getActiveItemById={getCity}
          />
        );
      case "Locality":
        return (
          <React.Fragment>
            <InfiniteScrollDropdown
              id="activeCityDropdown"
              setPriorityFlag={setPriorityFlag}
              priorityFlag={priorityFlag}
              appliedFilters={{}}
              getActiveList={getCityList}
              nextPage={nextPageCity}
              resKey="cities"
              modalState={modalState}
              keyName="activeCityId"
              stateDependent={true}
              labelKey="city_name"
              getDataLabelKey="city.city_name"
              keyTypeToSet="id"
              disabled={checkIfDisabled("activeCityId")}
              label="City"
              handleChange={setActiveCity}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
            />
            {/* <InputLabel htmlFor="outlined-adornment-amount">Locality</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            label="Locality"
            value={initialState.entityValue}
            labelWidth={100}
            onChange={(e)=>handleChange("entityValue",e.target.value)}
          >
          </Select> */}
            <InfiniteScrollDropdown
              id="activeLocalityDropdown"
              setPriorityFlag={setPriorityFlag}
              priorityFlag={priorityFlag}
              appliedFilters={activeCityId ? { city_id: activeCityId } : {}}
              appliedFilterValue={activeCityId}
              getActiveList={getLocalityList}
              nextPage={props.nextPageLocality}
              resKey="localities"
              modalState={modalState}
              keyName="entityValue"
              labelKey="locality_name"
              labels={["locality_name", "id"]}
              getDataLabelKey="locality.locality_name"
              keyTypeToSet="id"
              getActiveItemById={props.getLocality}
              disabled={checkIfDisabled("entityValue")}
              label="Locality"
              handleChange={handleChange}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeFilters={activeFiltersToggle}
              activeElement={activeFeatureToggle}
            />
          </React.Fragment>
        );
      default:
        return "";
    }
  };

  const checkIfDisabled = (key) => {
    return modalState === "Edit"
      ? disabledFieldsInEditState.includes(key)
        ? true
        : false
      : false;
  };

  const getUploadTitle = () => {
    return initialState["entitySubType"]
      ? initialState["entitySubType"] + "S"
      : initialState["entityType"]
      ? initialState["entityType"] + "_IDS"
      : "File";
  };

  const baseUrl = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        "/zgw/sample/"
      )
    : "";
  const defaultDownlaodUrl = baseUrl + "bulk_toggle_user_id.csv";

  const getSampleDownloadUrl = () => {
    //get url to download sample csv file
    switch (initialState.entityType) {
      case "Locality":
        return baseUrl + "bulk_toggle_locality_id.csv";
      case "Country":
        return baseUrl + "bulk_toggle_country_id.csv";
      case "City":
        return baseUrl + "bulk_toggle_city_id.csv";
      case "User":
        if (initialState.featureScope === "driver") {
          return baseUrl + "bulk_toggle_driver_ids.csv";
        } else if (initialState.featureScope === "customer") {
          return baseUrl + "bulk_toggle_public_customer_id.csv";
        } else {
          return initialState.entitySubType
            ? initialState.entitySubType === "USER_ID"
              ? baseUrl + "bulk_toggle_user_id.csv"
              : initialState.entitySubType === "MERCHANT_EXTERNAL_ID"
              ? baseUrl + "bulk_toggle_merchant_external_id.csv"
              : baseUrl + "bulk_restaurant_id.csv"
            : defaultDownlaodUrl;
        }
      default:
        return defaultDownlaodUrl;
    }
  };

  const setCurrentToggleStatus = (val) => {
    if (val !== undefined) {
      if (val === true || val === "true") {
        setToggleStatus("enable");
      } else if (val === false || val === "false") {
        setToggleStatus("disable");
      }
    }
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  useEffect(() => {
    modalState == "Filter" && initialState.featureScope
      ? props.getFeatureList(
          { scope: initialState.featureScope },
          { pageSize: 2000 }
        )
      : props.resetState({ state: "featuresList" });
  }, [modalState, initialState.featureScope]);

  useEffect(() => {
    //reset callback_key and presign_url for bulk upload
    setCallback_key("");
    setPresign_url("");
    if (activeId) {
      props.getFeatureToggle(activeId).then((res) => {
        res && setPriorityFlag(1);
      });
    }
    //reset the reducer state to show empty modal
    if (modalState === "Add" && Object.keys(activeFeatureToggle).length > 0) {
      props.resetStateFeatureToggle({ state: "activeFeatureToggle" });
    }
    if (modalState === "Add" || modalState === "Filter") {
      setPriorityFlag(1);
    }
  }, [activeId, modalState]);

  //reset feature list
  useEffect(() => {
    initialState.featureScope
      ? getFeatureList({ scope: initialState.featureScope }, { pageSize: 2000 })
      : props.resetState({ state: "featureList" });
  }, [initialState.featureScope]);

  useEffect(() => {
    getCarriersList().then((carriers_list) => {
      carrierIdOptions.current = carriers_list.carriers
    })
  }, [])

  useEffect(() => {
    //set the initial state of form in modal
    if (Object.keys(activeFeatureToggle).length > 0 && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFeatureToggle[key]
          ? activeFeatureToggle[key]
          : getInitialState(initialState, key);
      });
      values.setConditions = true;
      values.conditionsList =
        typeof values.conditions === "object"
          ? values.conditions
          : parseString(values.conditions);
      values.conditionsList =
        values.conditionsList == null || values.conditionsList == undefined
          ? []
          : values.conditionsList;
      values["enabled"] =
        typeof values["enabled"] === "boolean" ? values["enabled"] : false;
      setCurrentToggleStatus(values["enabled"]);
      setInitialState(values);
      values.conditionsList.forEach((condition) => {
        if(condition.Name=="validate_time") {
            setStartTime(condition.Value[0])
            setEndTime(condition.Value[1])
         }
         if(condition.Name=="is_slot_driver") {
          if(condition.Value == true){
             slotDriverInitialState.current = "True"
          }
          else {
            slotDriverInitialState.current = "False"
          }
          }
          if (condition.Name == "carrier_id") {
            getCarriersList().then((carriers_list) => {
              carrierIdOptions.current = carriers_list.carriers
              var carrierTypes = []
              condition.Value.forEach((carrier_id) => {
                const carrier_type = carrierIdOptions.current.find((key) => key.id === carrier_id).carrier_type
                carrierTypes.push(carrier_type)
              })
              setSelectedCarrierIds(carrierTypes)
              carrierIds.current = condition.Value
            })
          }
      })
    }
    if (
      Object.keys(activeFiltersToggle).length > 0 &&
      modalState === "Filter"
    ) {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFiltersToggle[key] ? activeFiltersToggle[key] : "";
      });
      values["serviceId"] = [];
      setCurrentToggleStatus(values["enabled"]);
      setPriorityFlag(1);
      setInitialState(values);
    }
  }, [activeFeatureToggle, activeFiltersToggle]);

  const getRequiredButtonPerms = () => {
    if (modalState === "Edit") {
      return [allActions.UPDATE];
    } else if (modalState === "Add") {
      return [allActions.CREATE];
    }
    return undefined;
  };

  const isOptionDisabled = (val) => {
    if (val === "Both(Enable & Disable)" && modalState !== "Filter") {
      return true;
    }
  };

  const isConditionTypeOptionDisabled = (option, conditionIndex) => {
    if (option == "Source ID" && initialState.featureScope == "driver") {
      return true;
    }
    if (option == "Slot Driver" && initialState.featureScope != "driver") {
      return true;
    }
    if (option == "Carrier ID" && initialState.featureScope != "driver") {
      return true;
    }
    let disable = false;
    initialState.conditionsList.forEach((conditionDetail, index) => {
      let conditionType = getInputLabel(
        conditionDetail.Name,
        conditionTypeOptions,
        "key",
        "label"
      );

      if (conditionType == option && index != conditionIndex) {
        disable = true;
      }
    });
    return disable;
  };

  const conditionValueCheck = (detailCondition) => {
    switch (detailCondition.Name) {
      case "app_version":
        if (detailCondition.Value == "") {
          return "";
        }
        try {
          const vArray = detailCondition.Value.split(".");
          if (vArray.length != 3) {
            return "Not a valid app version";
          }
        } catch {
          return "Not a valid app version";
        }

        break;
    }
    return "";
  };

  const handleAddCondition = () => {
    setDropDownModalState("Add");
    const updatedInitialState = {
      ...initialState,
      conditionsList: [
        ...initialState.conditionsList,
        {
          Name: "",
          Comparator: "",
          Value: "",
        },
      ],
    };
    setInitialState(updatedInitialState);
  };

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState === "Check" ? "Check Toggle Status" :
         modalState === "Add" ? "Create Feature Toggle" : 
         modalState +" Feature Toggle"}`}
      handleClose={handleClose}
      id="FeatureToggleFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          {modalState === "Filter" && (
            <Button
              data-testid="filterFeatureBtn"
              onClick={handleClearFilters}
              className="sushi-btn"
            >
              Clear
            </Button>
          )}
          <Permission requiredPerms={getRequiredButtonPerms()}>
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={handleSubmit}
            >
              {modalState === "Filter" ? "Apply" : "Submit"}
            </Button>
          </Permission>
          {modalState === "Check" && featureEnabledTextDisplay!=="" && (
            featureEnabledTextDisplay === true ? (
             <CheckFeatureResult>
              <p className="featureEnabledBtnTextEnabled">Enabled</p>
            </CheckFeatureResult>
            ) : 
            <CheckFeatureResult>
              <p className="featureEnabledBtnTextDisabled">Disabled</p>
            </CheckFeatureResult>
          )}
        </BottomSectionModal>
      }
    >
      {modalState === "Edit" && (
        <Input
          value={initialState.id}
          data-testid="featureToggleId"
          id="sushi-input"
          disabled
          label="Feature Toggle ID"
        />
      )}
      <PaginatedReactDropdown
        options={scopeOptions}
        data-testid="featureToggleScope"
        labelKey="label"
        valueKey="key"
        labelWidth="16%"
        disabled={checkIfDisabled("featureScope")}
        value={getInputLabel(
          initialState.featureScope,
          scopeOptions,
          "key",
          "label"
        )}
        handleChange={handleChange}
        keyToChange="featureScope"
        placeholder="Feature Scope"
        showCross={false}
        id="featureToggleScopeDropdown"
      />
      {/* todo:- sort options after lower casing */}
      <Autocomplete
        value={initialState.featureName}
        onChange={(event, newValue) => {
          handleChange("featureName", newValue);
        }}
        disabled={checkIfDisabled("featureName")}
        closeIcon={false}
        id="controllable-states-demo"
        options={getSortedList(
          featureList.filter((val) => !val["isDeleted"]),
          "name"
        )}
        // getOptionLabel={option => option}
        // renderOption={(option) => <span>{option.name}</span>}
        style={{ width: 300 }}
        renderInput={(params) => (
          <TextField {...params} label="Feature Name" variant="outlined" />
        )}
      />
      <PaginatedReactDropdown
        options={entityTypeOptions}
        data-testid="featureToggleEntityType"
        labelKey="label"
        valueKey="key"
        labelWidth="16%"
        disabled={checkIfDisabled("entityType")}
        value={getInputLabel(
          initialState.entityType,
          entityTypeOptions,
          "key",
          "label"
        )}
        handleChange={handleChange}
        keyToChange="entityType"
        placeholder="Toggle Scope"
        showCross={false}
        id="featureToggleEntityTypeDropdown"
      />

      {/* get Entity Sub Type field */}
      {getEntitySubType()}

      {isBulkUpload ? (
        // file uplaod
        <Permission requiredPerms={[allActions.BULK_CREATE]}>
          <FileUpload
            title={getUploadTitle()}
            uploadUrl="/feature/toggle/bulk"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callbackKey"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
          />
          <InformationBar
            sampleUrl={getSampleDownloadUrl()}
          />
        </Permission>
      ) : (
        // get Elements for Toggle For field , which depends on Toggle Scope field
        initialState.entityType && getEntityValueFields()
      )}

      {modalState === "Add" && (
        <Permission requiredPerms={[allActions.BULK_CREATE]}>
          <Checkbox
            value="isBulkUpload"
            color={variables.red500}
            checked={isBulkUpload}
            onChange={(e) => handleCheckBoxChange(e.isBulkUpload)}
            className="sushi-checkbox mb-20"
            data-testid="isBulkUploadFeatureToggle"
            label={"Is Bulk Upload?"}
          />
        </Permission>
      )}

      {/* <div className="form-grid grid-2"> */}
      {modalState !== "Check" ? 
      (
       <PaginatedReactDropdown
         options={statusOptions}
         isOptionDisabled={isOptionDisabled}
         data-testid="featureToggleStatus"
         labelKey="label"
         valueKey="key"
         labelWidth="10%"
         disabled={checkIfDisabled("enabled")}
         value={getInputLabel(toggleStatus, statusOptions, "key", "label")}
         handleChange={handleStatusChange}
         keyToChange="toggleStatus"
         placeholder="Status"
         showCross={false}
         id="toggleStatusDropdown"
       />
      ) : 
      null
      }

      {initialState.conditionsList.length
        ? (modalState === "Edit" || modalState === "Add") &&
          initialState.featureScope != "" &&
          initialState.conditionsList.map((detailCondition, index) => {
            return (
              <ConditionSection>
                <p className="sectionHeading">Condition {index + 1}</p>
                <PaginatedReactDropdown
                  options={conditionTypeOptions}
                  data-testid={`featureConditionOption${index}`}
                  labelKey="label"
                  valueKey="key"
                  labelWidth="17%"
                  value={getInputLabel(
                    detailCondition.Name,
                    conditionTypeOptions,
                    "key",
                    "label",
                    false
                  )}
                  isOptionDisabled={isConditionTypeOptionDisabled}
                  extraParamsOptionDisable={[index]}
                  handleChange={handleConditionListChange}
                  keyToChange="Name"
                  extraParams={[index]}
                  placeholder="Condition Type"
                  showCross={false}
                  id={`featureConditionOption${index}`}
                />
                <PaginatedReactDropdown
                  options={comparatorOptions}
                  data-testid={`featureComparatorOption${index}`}
                  labelKey="label"
                  valueKey="key"
                  labelWidth="14%"
                  value={getInputLabel(
                    detailCondition.Comparator,
                    comparatorOptions,
                    "key",
                    "label",
                    true
                  )}
                  handleChange={handleConditionListChange}
                  keyToChange="Comparator"
                  extraParams={[index]}
                  isOptionDisabled={(option) => {
                    switch (initialState.conditionsList[index].Name) {
                      case "app_version":
                        return option == "In" || option == "Not in";
                      case "service_id":
                        return option != "In" && option != "Not in";
                      case "source_id":
                        return option != "In" && option != "Not in";
                      case "carrier_id":
                        return option != "In" && option != "Not in";
                      case "validate_time":
                        return option != "In" && option != "Not in";
                      case "is_slot_driver":
                        return option != "Equals to"
                      default:
                        return false;
                    }
                  }}
                  placeholder="Comparator"
                  showCross={false}
                  id={`featureComparatorOption${index}`}
                />
                {detailCondition.Name == "service_id" ? (
                  <InfiniteScrollDropdown
                    id={`driverServicesDropdown${index}`}
                    priorityFlag={true}
                    activeElement={detailCondition}
                    getActiveList={getDriverServices}
                    resKey="driver_services"
                    modalState={dropDownModalState}
                    keyName="Value"
                    labelKey="name"
                    getDataLabelKey="driver_services.name"
                    keyTypeToSet="id"
                    label="Delivery Services"
                    handleChange={handleConditionListChange}
                    extraParams={[index]}
                    getActiveItemById={getDriverServiceByIds}
                    multiple
                  />
                ) :
                detailCondition.Name == "validate_time" ? (
                  <SetTimeSection>
                     <TimePickerInput
                       showSecond={true}
                       className="start-time-picker"
                       label="Start Time"
                       val={startTime}
                       handleChange={handleTimeChange}
                       keyToChange="time"
                       extraParams={{ type: "start", index: index}}
                      />
                      <TimePickerInput
                       showSecond={true}
                       className="end-time-picker"
                       label="End Time"
                       val={endTime}
                       handleChange={handleTimeChange}
                       keyToChange="time"
                       extraParams={{ type: "end", index: index }} 
                      />
                      <CrossCircle onClick={(e)=>{
                        setStartTime("00:00:00");
                        setEndTime("00:00:00");
                        handleConditionListChange("Comparator", 4, index)
                        }} className="cross" />
                    </SetTimeSection>
                ) : 
                detailCondition.Name == "carrier_id" ? (
                    <MultiSelectCheckboxDropdown
                        options={carrierIdOptions.current}
                        key="id"
                        options_label="carrier_type"
                        selectedValues={selectedCarrierIds}
                        handleChange={handleCarrierIdChange}
                        keyToChange="personName"
                        width={565}
                        extraParams={{index: index}}
                    />
                ) :
                detailCondition.Name == "is_slot_driver" ? (
                  <SlotDriverSection>
                     <PaginatedReactDropdown
                      options={slotDriverOptions}
                      data-testid="is_slot_driver"
                      labelKey="label"
                      valueKey="key"
                      labelWidth="15%"
                      value={slotDriverInitialState.current}
                      handleChange={handleChange}
                      keyToChange="slot_driver"
                      placeholder="Slot Driver"
                      showCross={true}
                      id="featureScopeDropdown"
                      extraParams={[index]}
                      />
                    </SlotDriverSection>
                ) : (
                  <Input
                    value={detailCondition.Value}
                    data-testid={`featureConditionValue${index}`}
                    id="sushi-input"
                    onChange={(e) =>
                      handleConditionListChange("Value", e, index)
                    }
                    errorMsg={conditionValueCheck(detailCondition)}
                    label={getInputLabel(
                      detailCondition.Name,
                      conditionTypeOptions,
                      "key",
                      "label",
                      false
                    )}
                  />
                )}
              </ConditionSection>
            );
          })
        : null}

      {(modalState === "Edit" || modalState === "Add") &&
        initialState.featureScope != "" && (
          <>
            <AddConditionContainer justify={"flex-end"}>
              <div
                className="flex delete-icon"
                onClick={() => {
                  handleAddCondition();
                }}
              >
                <PlusCircle color={variables.red500} size={20} />
                <span>
                  Add {initialState.conditionsList.length ? "another" : ""}{" "}
                  condition
                </span>
              </div>
            </AddConditionContainer>
            {initialState.conditionsList.length !== 0 ? (
              <React.Fragment>
                <p className="mb-20 ml-12 opacity-5 text-grey">
                  <b>This is the final condition to be sent:</b>
                </p>
                <Textarea
                  id="sushi-textarea"
                  data-testid="featureConditions"
                  borderColor={variables.primaryColor}
                  innerWidth="100%"
                  className="mb-20"
                  resize="none"
                  label="Conditions"
                  disabled={true}
                  value={initialState.conditions}
                />
              </React.Fragment>
            ) : null}
          </>
        )}

      {modalState === "Edit" && (
        <Input
          value={getReadableDateTime(initialState.updatedAt)}
          data-testid="updatedAt"
          id="sushi-input"
          disabled
          label="Updated At"
        />
      )}

      {/* change log list */}
      {modalState === "Edit" && (
        <ChangeLogList
          changes={initialState.changes}
          tableFields={ChangeLogTableFields}
        />
      )}
    </NoFooterModal>
  );
};

const ConditionSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.75rem;
    margin-top: 1rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const CheckFeatureResult = styled.div`
  margin-right: 2rem;
  font-weight: 500;
  color: ${variables.white};
  .featureEnabledBtnTextEnabled {
    background-color: ${variables.green500};
    padding: 0.8rem;
    border-radius: 5px;
  } 
  .featureEnabledBtnTextDisabled {
    background-color: ${variables.red500};
    padding: 0.8rem;
    border-radius: 5px;
  }
`;

const AddConditionContainer = styled(FlexContainer)`
  span {
    color: ${variables.red500};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const SetTimeSection =styled.div`
  {
  display: flex;
  }
`;

const SlotDriverSection =styled.div`
  {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  }
`;

function mapStateToProps(state) {
  const { FeatureToggle, Country, City, Locality, Feature } = state;
  return {
    activeFeatureToggle: FeatureToggle.activeFeatureToggle,
    activeFiltersToggle: FeatureToggle.activeFiltersToggle,
    countryList: Country.countryList,
    cityList: City.cityList,
    localityList: Locality.localityList,
    featureList: Feature.featureList,
    currentPageFeatureToggle: FeatureToggle.currentPageFeatureToggle,
    nextPageCountry: Country.nextPage,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
    allLocalityList: Locality.allLocalityList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createFeatureToggle: bindActionCreators(
      FeatureToggleActions.createFeatureToggle,
      dispatch
    ),
    getFeatureToggleList: bindActionCreators(
      FeatureToggleActions.getFeatureToggleList,
      dispatch
    ),
    checkFeatureToggleEnabled: bindActionCreators(
      FeatureToggleActions.checkFeatureToggleEnabled,
      dispatch
    ),
    getFeatureToggle: bindActionCreators(
      FeatureToggleActions.getFeatureToggle,
      dispatch
    ),
    resetStateFeatureToggle: bindActionCreators(
      FeatureToggleActions.resetStateFeatureToggle,
      dispatch
    ),
    getCountryList: bindActionCreators(CountryActions.getCountryList, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    getFeatureList: bindActionCreators(FeatureActions.getFeatureList, dispatch),
    resetState: bindActionCreators(FeatureActions.resetState, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getCountry: bindActionCreators(CountryActions.getCountry, dispatch),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getDriverServices: bindActionCreators(
      DriverServicesActions.getDriverServices,
      dispatch
    ),
    getDriverServiceByIds: bindActionCreators(
      DriverServicesActions.getDriverServiceByIds,
      dispatch
    ),
    getCarriersList: bindActionCreators(
      CarrierActions.getCarriersList,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureToggleFormModal);
